// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"cb355f6d","239":"848279b6","455":"3b2a88df"}[chunkId] + ".chunk.js";
};